import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './puzzle-analytics-consent.actions';
import { Injectable } from '@angular/core';
import { PuzzleStorageEngine } from '../../../../web/src/app/puzzle-storage-engine.service';
// @dynamic
@State<boolean>({
  name: 'cookieConsent',
  defaults: false,
})
@Injectable()
export class PuzzleCookieConsentState {
  constructor(private storageEngine: PuzzleStorageEngine) {}

  @Action(actions.SetConsent)
  SetConsent(store: StateContext<boolean>, action: actions.SetConsent) {
    this.storageEngine.setConsent();
    store.setState(true);
  }

  @Action(actions.RevokeConsent)
  RevokeConsent(store: StateContext<boolean>, action: actions.RevokeConsent) {
    store.setState(false);
    this.storageEngine.revokeConsent();
  }
}
